import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./UserSlice";
import dashboardReducer from "./DashboardSlice";
import authReducer from "./AuthSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    dashboard: dashboardReducer,
    auth: authReducer,
  },
});

export default store;
